import { Stack } from '@mui/material'
import { FC, useMemo } from 'react'
import { LocationInfo } from './LocationInfo'
import { useLocation as useLocationData } from '../../../../api/apiQueries'
import { useParams } from 'react-router-dom'
import { getLocationBannerMessage } from './location-banner.utils'
import { MonitoringCertificate } from './MonitoringCertificate'
import { EmergencyContacts } from './EmergencyContacts'
import { AdditionalSettings } from './AdditionalSettings'
import {
  READ_LOCATION_ADDRESS_SCOPE,
  READ_LOCATION_CONTACTS_SCOPE,
  READ_LOCATION_MONITORING_SCOPE,
  READ_LOCATIONS_SCOPE
} from '../../../../constants'
import { AuthCheck } from '../../../../components/AuthCheck'
import { Banner } from '../../../../components/Banner/Banner'

export const LocationSettingsTab: FC = () => {
  const locationId = useParams().sid
  const locationQuery = useLocationData(locationId)

  const location = locationQuery.data

  const bannerDetails = useMemo(() => (location ? getLocationBannerMessage(location) : null), [location])

  return (
    <Stack direction="column" data-testid="location-settings">
      {location && (
        <>
          <AuthCheck has={READ_LOCATION_MONITORING_SCOPE}>
            {bannerDetails && (
              <Banner type={bannerDetails.type} title={bannerDetails.title} body={bannerDetails.body} data-testid="location-banner" />
            )}
          </AuthCheck>
          <Stack direction="column" spacing="var(--spacing-l)">
            <AuthCheck has={[READ_LOCATIONS_SCOPE, READ_LOCATION_ADDRESS_SCOPE]} mode={'any'}>
              <LocationInfo location={location} />
            </AuthCheck>
            <AuthCheck has={READ_LOCATION_CONTACTS_SCOPE}>
              <EmergencyContacts location={location} />
            </AuthCheck>
            <AdditionalSettings location={location} templateId={location?.templateId ?? ''} dispatchNotes={location?.dispatchNotes ?? ''} />
            <MonitoringCertificate location={location} />
          </Stack>
        </>
      )}
    </Stack>
  )
}
